import React from 'react'
import styles from './WahooFlow.scss'
import { S2DLayout } from '../../S2DLayout'
import { s2dMessages } from '../../intlMessages'
import { FancyCheckmark } from 'common/FancyCheckmark'
import { CreateAccountStep } from '../../CreateAccountStep'
import payoffImg from 'assets/images/send_to_device/payoff.svg'
import { Msg, commonCTAs } from 'lib/localization'
import { FormattedMessage as T } from 'react-intl'

export class WahooFlow extends React.PureComponent {
  render () {
    const { subtitle, selectedDevice, step, route, routeId, onPrev, onNext } = this.props
    const currentUser = window.rwgps && window.rwgps.config.currentUser

    if (!currentUser.id) {
      return <CreateAccountStep {...this.props} selectedDevice={selectedDevice} />
    }

    return (
      <S2DLayout
        title={<Msg m={s2dMessages.sendTo} values={{ device: 'ELEMNT/BOLT' }} />}
        subtitle={subtitle}
        onClickPrev={onPrev}
        onClickNext={step !== 5 ? onNext : () => { window.location.href = `/routes/${routeId}` }}
        nextText={step !== 5 ? <Msg capitalized m={commonCTAs.next} /> : <Msg m={s2dMessages.returnToRoute} />}
        step={step}
        stepCount={5}>
        <div className={styles.WahooFlow}>
          {step === 2 && <Step2 routeName={route && route.name} />}
          {step === 3 && <Step3 />}
          {step === 4 && <Step4 />}
          {step === 5 && <Step5 />}
        </div>
      </S2DLayout>
    )
  }
}

const Step2 = ({ routeName }) => (
  <div className={styles.instructions}>
    <p>
      <T
        id='s2d.wahoo1'
        defaultMessage='{name} has been added to your pinned routes and is available for navigation with your Wahoo device'
        values={{ name: routeName && <span>"<strong>{routeName}</strong>"</span> }} />
    </p>
    <FancyCheckmark />
  </div>
)

const Step3 = () => (
  <div className={styles.instructions}>
    <p>
      <T
        id='s2d.wahooStep3Download'
        defaultMessage='Download the <strong>Wahoo ELEMNT companion app</strong> to your phone.'
        values={{ strong: (...c) => <strong>{c}</strong> }} />
    </p>
    <p>
      <T id='s2d.wahooStep3OnceDownloaded' defaultMessage='Once downloaded, open the Wahoo app and pair your Wahoo ELEMNT device with your phone.' />
    </p>
    <p>
      <T
        id='s2d.wahooStep3Next'
        defaultMessage='Next, link your Ride with GPS account within the Wahoo app using the <a>Linked Accounts</a> settings.'
        values={{ a: (...c) => <a target='_blank' href='https://ridewithgps.com/help/wahoo-elemnt#authorize-rwgps'>{c}</a> }} />
    </p>
    <div className={styles.centeredImg}>
      <img src='/images/routes/wahoo_app_badge.png' />
    </div>
  </div>
)

// worth testing: https://groups.google.com/forum/#!topic/wahoo-elemnt-users/GnJNTd2wJDY
// (pinned rides may break Ride Starred filter)
const Step4 = () => (
  <div className={styles.instructions}>
    <p>
      <T
        id='s2d.wahooStep41'
        defaultMessage='On your ELEMNT, bring up the <strong>Routes</strong> screen, and press the <strong>Sync</strong> button.'
        values={{ strong: (...c) => <strong>{c}</strong> }} />
    </p>
    <p>
      <T
        id='s2d.wahooStep42'
        defaultMessage='Once syncing is complete, sort your synced routes by <strong>Starred</strong>, bringing starred routes to the top of your route list.'
        values={{ strong: (...c) => <strong>{c}</strong> }} />
    </p>
    <p>
      <T id='s2d.wahooStep43' defaultMessage='Your route will be visible as a starred route in your route list. Select your route, and press Navigate to begin navigation.' />
    </p>
  </div>
)

const Step5 = () => (
  <div className={styles.instructions}>
    <p>
      <T id='s2d.wahooStep51' defaultMessage='After a brief warm up, your Wahoo ELEMNT will begin navigation.' />
    </p>
    <p><Msg m={s2dMessages.enjoyYrRide} /></p>
    <div className={styles.centeredImg}>
      <img src={payoffImg} width='150' height='150' />
    </div>
  </div>
)
